export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_IS_WIDGET_OPEN = 'SET_IS_WIDGET_OPEN'
export const SET_PARENT_SIZE_INFO = 'SET_PARENT_SIZE_INFO'
export const SET_WIDGET_SETTINGS = 'SET_WIDGET_SETTINGS'
export const SET_WIDGETS = 'SET_WIDGETS'
export const SET_PRACTICE_LOCATIONS = 'SET_PRACTICE_LOCATIONS'
export const SET_IS_MOBILE_SAFARI = 'SET_IS_MOBILE_SAFARI'
